var keyMirror = require( 'key-mirror' );

module.exports = keyMirror({

	LOAD_MY_FEEDBACK 				: 	null,
	STORE_FEEDBACK 					: 	null,
	ACKNOWLEDGE_ITEM 				: 	null
});


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/constants/FeedbackConstants.js